/// <reference types="./getPrincipals.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ok } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryMany } from '../QueryFunctions.js';
import { toOpaqueCursor } from '../search/OpaqueCursor.js';
import { addConnectionOrderByAndLimit, addConnectionPagingFilter, resolveConnectionPagingAndOrdering, } from '../utils/ConnectionUtils.js';
export async function authGetPrincipals(database, context, paging) {
    const queryResult = generateGetPrincipalsQuery(database, paging);
    if (queryResult.isError())
        return queryResult;
    const connectionResult = await queryMany(database, context, queryResult.value);
    if (connectionResult.isError())
        return connectionResult;
    const { hasMore, edges } = resolveConnectionPagingAndOrdering(paging, connectionResult.value);
    return ok({ hasMore, edges: edges.map((edge) => convertEdge(database, edge)) });
}
function convertEdge(database, edge) {
    const cursor = toOpaqueCursor(database, 'int', edge.id);
    return {
        cursor,
        provider: edge.provider,
        identifier: edge.identifier,
        subjectId: edge.uuid,
    };
}
function generateGetPrincipalsQuery(database, paging) {
    const reverse = false;
    const { sql, query } = createSqliteSqlQuery();
    sql `SELECT p.id, p.provider, p.identifier, s.uuid FROM principals p`;
    sql `JOIN subjects s ON p.subjects_id = s.id`;
    sql `WHERE`;
    const pagingFilterResult = addConnectionPagingFilter(database, sql, paging, 'int', reverse, (sql) => sql `p.id`);
    if (pagingFilterResult.isError())
        return pagingFilterResult;
    addConnectionOrderByAndLimit(sql, paging, reverse, (sql) => sql `p.id`);
    return ok(query);
}
//# sourceMappingURL=getPrincipals.js.map